// frontend/src/pages/Socrates/components/Dashboard/QuickActions/index.js

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPlus, faCog, faGlobe, 
  faUsers, faChartLine 
} from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import SocratesCard from '../../common/SocratesCard';
import styles from './QuickActions.module.css';

const QuickActions = ({ onNavigate, onCreateTemplate }) => {
  const { t } = useLanguage();

  const actions = [
    {
      id: 'create-template',
      title: t('create_template'),
      description: t('create_new_template_description'),
      icon: faPlus,
      color: 'primary',
      onClick: onCreateTemplate
    },
    {
      id: 'manage-templates',
      title: t('manage_templates'),
      description: t('view_edit_templates_description'),
      icon: faCog,
      color: 'secondary',
      onClick: () => onNavigate('templates')
    },
    {
      id: 'system-templates',
      title: t('view_system_templates'),
      description: t('explore_system_templates_description'),
      icon: faGlobe,
      color: 'info',
      onClick: () => onNavigate('templates')
    },
    {
      id: 'user-templates',
      title: t('view_user_templates'),
      description: t('manage_user_templates_description'),
      icon: faUsers,
      color: 'success',
      onClick: () => onNavigate('templates')
    }
  ];

  return (
    <div className={styles.quickActions}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          <FontAwesomeIcon icon={faChartLine} className={styles.titleIcon} />
          {t('quick_actions')}
        </h2>
        <p className={styles.subtitle}>{t('quick_actions_description')}</p>
      </div>
      
      <div className={styles.actionsGrid}>
        {actions.map((action) => (
          <SocratesCard
            key={action.id}
            className={`${styles.actionCard} ${styles[action.color]}`}
            onClick={action.onClick}
            variant="outlined"
          >
            <div className={styles.actionContent}>
              <div className={styles.actionIcon}>
                <FontAwesomeIcon icon={action.icon} />
              </div>
              <div className={styles.actionInfo}>
                <h3 className={styles.actionTitle}>{action.title}</h3>
                <p className={styles.actionDescription}>{action.description}</p>
              </div>
            </div>
          </SocratesCard>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;